import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-global-loader',
  templateUrl: './global-loader.component.html',
  styleUrl: './global-loader.component.scss',
  standalone: false
})
export class GlobalLoaderComponent {
  @Input() message!: string;
}
